import { render, staticRenderFns } from "./KTransition.vue?vue&type=template&id=1af04e4a&scoped=true"
import script from "./KTransition.vue?vue&type=script&lang=js"
export * from "./KTransition.vue?vue&type=script&lang=js"
import style0 from "./KTransition.vue?vue&type=style&index=0&id=1af04e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af04e4a",
  null
  
)

export default component.exports